import {createGlobalStyle} from "styled-components";

const GlobalStyles = createGlobalStyle`

@import url('https://fonts.googleapis.com/css2?family=Outfit&display=swap');


*{
    font-family: 'Outfit', sans-serif;
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    color: #dddddd;
}
`

export default GlobalStyles